/*
 * @Author: zhangsheng
 * @Date: 2023-09-15 10:21:15
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-09-21 14:36:02
 * @FilePath: \panda-index-sicermem-frontend\src\i18n.js
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import dayjs from 'dayjs';
import zh from './locales/zh.ts';
import en from './locales/en.ts';

const resources = {
  zh: {
    translation: zh,
  },
  en: {
    translation: en,
  },
};

i18n
  .use(LanguageDetector)
  // 注入 react-i18next 实例
  .use(initReactI18next)
  // 初始化 i18next
  // 配置参数的文档: https://www.i18next.com/overview/configuration-options
  .init({
    lng: localStorage.getItem('i18nextLng') || 'zh',
    fallbackLng: 'zh',//语言切换失败的默认语言
    resources,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

// new usage
i18n.services.formatter.add('DD/MM/YY', (value, lng, options) => {
  return dayjs(value).format('DD/MM/YY');
});

i18n.services.formatter.add('YYYY-MM-DD', (value, lng, options) => {
  return dayjs(value).format('YYYY-MM-DD');
});

export default i18n;
